<template>
  <section class="content-section primary">
    <div class="section-title">
        <!-- <div class="section-title-line"></div> -->
        <h1>WEICHGESTEINE</h1>
        <!-- <div class="section-title-line"></div> -->
    </div>
    <div class="container">
      <article class="detailed-info">
        <p>Zu den Weichgesteinen gehören unter anderem: Marmor, Kalksteine, Sandsteine, Muschelkalk, Travertin und Serpentinite. Sie sind vor allem für den Innenbereich geeignet und werden oft als Wand-, Boden- oder Treppenbelag verarbeitet. In Weichgesteinen ist meist Kalk oder Dolomit vorhanden, wodurch sie nicht säurefest und somit nur sehr bedingt im Außenbereich einsetzbar sind. Auch bei der Pflege der Weichgesteine ist es wichtig, die richtigen Pflegeprodukte einzusetzen, um z. B. Verfärbungen zu vermeiden.</p>
        <hr>
        <h2>Marmor - Zeitlos und elegant</h2>
        <p>Marmor ist wohl der bekannteste Naturstein unter den Weichgesteinen. Ihn gibt es in allen denkbaren Strukturen, Farbtönen und Texturen. Poliert kommt er am besten zur Geltung, überzeugt aber auch so durch seine edle Optik und hohe Farbintensität. </p>
        <hr>
        <div class="image-row">
      <div class="image-row-item"><img src="https://marmor-kunze.de/static/images/material/marmor1.jpg"></div>
      <div class="image-row-item"><img src="https://marmor-kunze.de/static/images/material/marmor2.jpg"></div>
      <div class="image-row-item"><img src="https://marmor-kunze.de/static/images/material/marmor3.jpg"></div>
        </div>
      </article>
      </div>
    </section>
</template>

<script>
export default {
  name: 'Weichgesteine',
  metaInfo: {
    title: 'Weichgesteine',
    meta:[
      { vmid: 'description', name: 'description', content: "Zu den Weichgesteinen gehören unter anderem: Marmor, Kalksteine, Muschelkalk, Travertin und Serpentinite. Sie sind vor allem für den Innenbereich geeignet und werden oft als Wand-, Boden- oder Treppenbelag verarbeitet."},
      { vmid: 'keywords', name: 'keywords', content: "Natursteine, Weichgesteine, Marmor, Travertin, Kalksteine, Weichgesteine Mönchengladbach"},
      
    ],
    links: [ {rel: 'canonical', href: 'https://www.marmor-kunze.de/material/weichgesteine'} ]
  },
 
}
</script>
j
<style>
</style>



// WEBPACK FOOTER //
// src/components/views/Weichgesteine.vue